import type { Messages } from "../../core/api";

export type CaregiverProfileSubsection = {
  id: string;
  label: string;
  status: "started" | "placeholder";
  hiddenForCaregiverStatuses?: string[];
  isBillingFeature?: boolean;
  isOnboardingOnly?: boolean;
  permissionKey?: Messages["AgencyMemberPermission"];
};

export type CaregiverProfileSection = {
  label: string;
  subsections: CaregiverProfileSubsection[];
};

export const caregiverProfileSections: CaregiverProfileSection[] = [
  {
    label: "Calendar",
    subsections: [
      {
        id: "calendar",
        label: "Calendar",
        status: "placeholder",
        hiddenForCaregiverStatuses: ["PENDING"],
        permissionKey: "view_caregiver_page_calendar",
      },
      {
        id: "list-view",
        label: "Assigned visits",
        status: "placeholder",
        hiddenForCaregiverStatuses: ["PENDING"],
        permissionKey: "view_caregiver_page_assigned_visits",
      },
      {
        id: "assigned-tasks",
        label: "Assigned Tasks",
        status: "placeholder",
        hiddenForCaregiverStatuses: ["PENDING"],
        permissionKey: "view_caregiver_page_assigned_tasks",
      },
      {
        id: "availability",
        label: "Availability",
        status: "started",
        permissionKey: "view_caregiver_page_availability",
      },
      {
        id: "attendance",
        label: "Attendance",
        status: "started",
        permissionKey: "view_caregiver_page_attendance",
      },
      {
        id: "visits-broadcasted",
        label: "Visits Broadcasted",
        status: "started",
        permissionKey: "view_caregiver_page_visits_broadcasted",
      },
      {
        id: "patient-list",
        label: "Patients",
        status: "started",
        permissionKey: "view_caregiver_page_visits_broadcasted",
      },
    ],
  },
  {
    label: "Profile",
    subsections: [
      {
        id: "about",
        label: "About",
        status: "started",
        permissionKey: "view_caregiver_page_about",
      },
      {
        id: "status-review",
        label: "Status review",
        status: "started",
        permissionKey: "view_caregiver_page_status_review",
      },
      {
        id: "staffing-preferences",
        label: "Staffing Preferences",
        status: "started",
        permissionKey: "view_caregiver_page_emergency",
      },
      {
        id: "extended-contact-details",
        label: "Extended Contact Details",
        status: "started",
        permissionKey: "view_caregiver_page_emergency",
      },
      {
        id: "emergency-contact",
        label: "Emergency Contact",
        status: "started",
        permissionKey: "view_caregiver_page_emergency",
      },
      {
        id: "validated-duties",
        label: "Validated Duties",
        status: "started",
        permissionKey: "view_caregiver_page_about",
      },
      {
        id: "supplies-shipments",
        isOnboardingOnly: true,
        label: "Caregiver Supplies",
        status: "started",
      },
      {
        id: "patient-caregiver-relationships",
        label: "Patient-Caregiver Relationships",
        status: "started",
      },
    ],
  },
  {
    label: "Compliance",
    subsections: [
      {
        id: "compliance",
        label: "Compliance",
        status: "placeholder",
        permissionKey: "view_caregiver_page_compliance",
      },
      {
        id: "compliance-automations",
        isOnboardingOnly: true,
        label: "Compliance Automations",
        status: "placeholder",
        permissionKey: "view_caregiver_page_compliance",
      },
      {
        id: "training-center",
        label: "Training Center",
        status: "started",
        permissionKey: "view_caregiver_page_training_center",
      },
      {
        id: "application",
        label: "Application",
        status: "started",
        permissionKey: "view_caregiver_page_application",
      },
    ],
  },
  {
    label: "Documents",
    subsections: [
      {
        id: "documents",
        label: "Documents",
        status: "started",
        permissionKey: "view_caregiver_page_documents",
      },
      { id: "faxes", label: "Faxes", status: "started" },
    ],
  },
  {
    label: "Payroll",
    subsections: [
      {
        id: "payroll",
        label: "Payroll",
        status: "placeholder",
        permissionKey: "view_caregiver_page_payroll",
      },
      {
        id: "direct-deposit-information",
        isOnboardingOnly: true,
        isBillingFeature: true,
        label: "Direct Deposit Information",
        status: "placeholder",
        permissionKey: "view_caregiver_direct_deposit_information",
      },
    ],
  },
  {
    label: "Administrative",
    subsections: [
      {
        id: "pay-rates",
        isBillingFeature: true,
        label: "Pay Rates",
        status: "placeholder",
        permissionKey: "view_caregiver_page_pay_rates",
      },
      {
        id: "payroll-tax-information",
        isBillingFeature: true,
        label: "Payroll Tax Information",
        status: "placeholder",
        permissionKey: "view_caregiver_page_payroll_tax",
      },
      { id: "hours-overrides", label: "Hours overrides", status: "placeholder" },
      {
        id: "recent-activity",
        label: "Recent Activity",
        status: "started",
        permissionKey: "view_caregiver_page_recent_activity",
      },
    ],
  },
];
